var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loan-details-step" },
    [
      _c(
        "FormGroup",
        { staticClass: "slider-wrap" },
        [
          _c("VueSlider", {
            attrs: {
              marks: (mark) => mark % 250 === 0,
              max: _vm.__amountRange.MAX,
              min: _vm.__amountRange.MIN,
              interval: 50,
              "tooltip-formatter": (val) => `$${Number(val).toLocaleString()}`,
              disabled: _vm.isTopUp,
              tooltip: "always",
              "tooltip-placement": "top",
            },
            model: {
              value: _vm.form.sliderAmount,
              callback: function ($$v) {
                _vm.$set(_vm.form, "sliderAmount", $$v)
              },
              expression: "form.sliderAmount",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "loan-stat-bar" }, [
        _c(
          "div",
          { staticClass: "loan-stat" },
          [
            _c("LoanTypeDisplayCard", {
              staticClass: "loan-stat__card",
              attrs: { amount: _vm.form.amount },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "loan-stat-divider" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "loan-stat" },
          [
            _c("RepaymentAmountDisplayCard", {
              staticClass: "loan-stat__card",
              attrs: {
                amount: _vm.form.amount,
                duration: _vm.form.terms,
                frequency: _vm.form.frequency,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-4" }, [
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Borrow Amount",
                  name: "amount",
                  floating: true,
                },
              },
              [
                _c("FmSelect", {
                  attrs: {
                    value: _vm.form.amount,
                    options: _vm.amountOptions,
                    icons: _vm.amountIcons,
                    disabled: _vm.isTopUp,
                  },
                  on: {
                    input: function ($event) {
                      _vm.form.amount = Number($event)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Duration",
                  name: "terms",
                  floating: true,
                },
              },
              [
                _c("FmSelect", {
                  attrs: {
                    value: _vm.form.terms,
                    options: _vm.durationOptions,
                    icons: _vm.durationIcons,
                    disabled: _vm.isTopUp,
                  },
                  on: {
                    input: function ($event) {
                      _vm.form.terms = Number($event)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "FormGroup",
              {
                attrs: {
                  "error-container": _vm.errorContainerName,
                  label: "Repayment Frequency",
                  name: "frequency",
                  floating: true,
                },
              },
              [
                _c("FmSelect", {
                  attrs: {
                    value: _vm.form.frequency,
                    options: _vm.frequencies,
                    icons: _vm.freqIcons,
                    disabled: _vm.isTopUp,
                  },
                  on: {
                    input: function ($event) {
                      _vm.form.frequency = $event
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      !_vm.isTopUp
        ? _c("Checkbox", {
            attrs: {
              "error-container": _vm.errorContainerName,
              name: "agreeLoanAmountCanChange",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ onClick, style }) {
                    return [
                      _c("div", { on: { click: onClick } }, [
                        _vm._v(
                          "\n        I understand that subject to Flash Money's lending criteria, the final loan amount and term may differ from\n        my application.\n      "
                        ),
                      ]),
                    ]
                  },
                },
              ],
              null,
              false,
              560076472
            ),
            model: {
              value: _vm.form.agreeLoanAmountCanChange,
              callback: function ($$v) {
                _vm.$set(_vm.form, "agreeLoanAmountCanChange", $$v)
              },
              expression: "form.agreeLoanAmountCanChange",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "paying_loan_amount", type: "hidden", value: "0" },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { id: "ga_user_id", name: "ga_user_id", type: "hidden" },
        domProps: { value: _vm.ga_user_id },
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "fm-section-label",
          attrs: { id: "loan-purpose-label" },
        },
        [_vm._v("Loan Purpose")]
      ),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          attrs: {
            "error-container": _vm.errorContainerName,
            name: "purpose.description",
          },
        },
        [
          _c("LoanPurposePicker", {
            attrs: { "aria-labelledby": "loan-purpose-label" },
            model: {
              value: _vm.form.purpose.description,
              callback: function ($$v) {
                _vm.$set(_vm.form.purpose, "description", $$v)
              },
              expression: "form.purpose.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !!_vm.selectedPurpose
        ? _c(
            "FormGroup",
            {
              attrs: {
                "error-container": _vm.errorContainerName,
                label: "Additional purpose details",
                name: "purpose.reason",
                floating: true,
              },
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.purpose.reason,
                    expression: "form.purpose.reason",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  name: "loan_purpose_details",
                  rows: "3",
                  placeholder: " ",
                },
                domProps: { value: _vm.form.purpose.reason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.purpose, "reason", $event.target.value)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          attrs: {
            "error-container": _vm.errorContainerName,
            label:
              "Can you foresee any reason you won't be able to repay this loan?",
            name: "inabilityToRepay",
          },
        },
        [
          _c("RadioButtonGroup", {
            attrs: {
              block: true,
              options: { no: "No", yes: "Yes" },
              name: "inability_to_repay",
              size: "sm",
            },
            model: {
              value: _vm.form.inabilityToRepay,
              callback: function ($$v) {
                _vm.$set(_vm.form, "inabilityToRepay", $$v)
              },
              expression: "form.inabilityToRepay",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.inabilityToRepay === "yes"
        ? _c(
            "FormGroup",
            {
              attrs: {
                "error-container": _vm.errorContainerName,
                label: "Please describe the reason",
                name: "inabilityToRepayReason",
                floating: true,
              },
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.inabilityToRepayReason,
                    expression: "form.inabilityToRepayReason",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "reason_for_foresee",
                  name: "reason_for_foresee",
                  placeholder: " ",
                },
                domProps: { value: _vm.form.inabilityToRepayReason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form,
                      "inabilityToRepayReason",
                      $event.target.value
                    )
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          attrs: {
            "error-container": _vm.errorContainerName,
            label: "Acknowledgement & Consent",
            name: "acknowledgementAndConsentGranted",
          },
        },
        [
          _c("AcknowledgementAndConsent", {
            model: {
              value: _vm.form.acknowledgementAndConsentGranted,
              callback: function ($$v) {
                _vm.$set(_vm.form, "acknowledgementAndConsentGranted", $$v)
              },
              expression: "form.acknowledgementAndConsentGranted",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("controls", null, null, { prev: null, next: _vm.onNext }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }